import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ActivationRequest } from "../../models/user.model";
import { UserService } from "../../services/user.service";

@Component({
  selector: "app-account-activation",
  templateUrl: "./account-activation.component.html",
  styleUrls: ["./account-activation.component.scss"],
})
export class AccountActivationComponent implements OnInit {
  activationRequest: ActivationRequest = new ActivationRequest();
  activationSuccessful: boolean;
  activationFailed: boolean;
  onDestroy$ = new Subject();

  constructor(
    private route: ActivatedRoute,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.activationSuccessful = false;
    this.activationFailed = false;

    // Get URL parameters
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((params) => {
        this.activationRequest.token = params["token"];
        this.activationRequest.email = params["email"];

        // Activate the registered user with the token and email supplied in the URL params
        this.userService
          .activateRegisteredUser(this.activationRequest)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data) => {
              this.activationSuccessful = true;
            },
            (error) => {
              this.activationFailed = true;
            }
          );
      });
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
